import { render, staticRenderFns } from "./live-away.vue?vue&type=template&id=aae73c28&scoped=true"
import script from "./live-away.vue?vue&type=script&lang=js"
export * from "./live-away.vue?vue&type=script&lang=js"
import style0 from "./live-away.vue?vue&type=style&index=0&id=aae73c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae73c28",
  null
  
)

export default component.exports